// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"635":"11ffdd97","787":"ead3f973","870":"e3ac0bd8"}[chunkId] + ".chunk.js";
};